// extracted by mini-css-extract-plugin
export default {"title":"BottomSheetTitle_title__YJdsz","center":"BottomSheetTitle_center__CfGBl"};